<div class="app search-i vertical-menu bg-1 sidebar-blue header-blue">
	<app-loader></app-loader>
	<mat-sidenav-container class="app-inner" [ngClass]="{ fixed: hideOverflow }">
		<mat-sidenav-content>
			<app-pilotpay-toolbar
				[isAdmin]="isAdmin"
				[payScaleId]="payScaleId"
				[displayName]="displayName"
				[isConnected]="isConnected"
				[employeeId]="employeeId"
			></app-pilotpay-toolbar>
			<div [ngClass]="{ 'overflow-hidden': hideOverflow }" class="body-container">
				<router-outlet *ngIf="isConnected"></router-outlet>
				<app-offline *ngIf="!isConnected"></app-offline>
			</div>
			<footer
				*ngIf="(router.url == '/pilotpay/dashboard' || router.url == '/pilotpay/admin') && isConnected"
				class="footer"
				[ngStyle]="router.url == '/pilotpay/admin' && { position: 'relative' }"
			>
				<div fxLayout="row">
					<span>Client Build : {{ clientBuild }}</span>
					<span fxFlex></span>
					<span fxLayoutAlign="end start"> {{ utcDate | date: 'HH:mm':'UTC' }} UTC</span>
				</div>
				<div fxLayout="row">
					<span>Server Build : {{ serverBuild }}</span>
					<span fxFlex></span><span>{{ utcDate | date: 'EEEE, MMMM d, y':'UTC' }} </span>
				</div>
			</footer>
		</mat-sidenav-content>
	</mat-sidenav-container>
</div>
